module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(gon.display_options.qrCodeCta) { ;
__p += '\n<a class="cta_item_container" data-product-id="' +
((__t = ( id )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('lightbox.cta.screen_reader_label', { ctaText: decode_utf8(link_text), product: decode_utf8(altTextProduct(title)) }) )) == null ? '' : __t) +
'">\n    ';
 } else { ;
__p += '\n    <a class="cta_item_container" href="' +
((__t = ( decode_utf8_link(link) )) == null ? '' : __t) +
'" target="' +
((__t = ( gon.display_options.ctaCurrentTab || gon.current_account.extra_fields.ctaCurrentTab ? '_parent' : '_blank')) == null ? '' : __t) +
'" data-product-id="' +
((__t = ( id )) == null ? '' : __t) +
'" aria-label="' +
((__t = ( I18n.t('lightbox.cta.screen_reader_label', { ctaText: decode_utf8(link_text), product: decode_utf8(altTextProduct(title)) }) )) == null ? '' : __t) +
'">\n        ';
 } ;
__p += '\n        <div class="cta_holder">\n            ';
 if(gon.display_options.stockThreshold && showLowStock && stockLabelLayout === "badge_above") { ;
__p += '\n            <span class="product_stock badge badge_above">\n                ' +
((__t = ( I18n.t('lightbox.cta.low_stock', { stock: stock }) )) == null ? '' : __t) +
'\n            </span>\n            ';
 } ;
__p += '\n\n            <div class="cta_img" style="background-image:url(\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\')">\n                <img alt="' +
((__t = ( decode_utf8(altTextProduct(title)) )) == null ? '' : __t) +
'" src=\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\' style="position: fixed; left: -100000px;" />\n            </div>\n            <div class="product_right">\n                ';
 if(gon.display_options.showProductCategoryLabel) { ;
__p += '\n                <p class="product_category_label">' +
((__t = ( productCategoryLabel(categories) )) == null ? '' : __t) +
'</p>\n                ';
 } ;
__p += '\n                <div class="product_name">\n                    ' +
((__t = ( decode_utf8(title) )) == null ? '' : __t) +
'\n                </div>\n                ';
 if (gon.display_options.showProductDescription) { ;
__p += '\n                    <p class="product_description_label">' +
((__t = ( productDescription )) == null ? '' : __t) +
'</p>\n                ';
 } ;
__p += '\n                <div class="pricing_container" data-product-id="' +
((__t = ( id )) == null ? '' : __t) +
'"></div>\n\n\n                ';
 if(gon.display_options.qrCodeCta) { ;
__p += '\n                    <div id="cta_qr_container">\n                        <div id="cta_qr"></div>\n                        <span>' +
((__t = ( qrCodeText )) == null ? '' : __t) +
'</span>\n                    </div>\n                ';
 } else { ;
__p += '\n                    <div id="cta_button" class="product_cta ' +
((__t = ( addClassIfTrue(is_default_product_cta, 'is_default') )) == null ? '' : __t) +
'" aria-hidden="true">' +
((__t = ( decode_utf8(link_text) )) == null ? '' : __t) +
'</div>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </a>\n';

}
return __p
}